import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface IClinicianDiseaseSlice {
    id: string | undefined;
    name: string | undefined;
    userId: string;
    disease_details?: IProject;
}

const initialState = { id: undefined, name: "", userId: "" } satisfies IClinicianDiseaseSlice as IClinicianDiseaseSlice;

const clinicianDiseaseSlice = createSlice({
    name: "clinicianDisease",
    initialState,
    reducers: {
        setClinicianDisease(state, action: PayloadAction<IClinicianDiseaseSlice>) {
            state.id = action.payload.id;
            state.name = action.payload.name;
            state.userId = action.payload.userId;
            if (state.id != undefined && state.id != "") {
                localStorage.setItem("current_project", state.id)
                localStorage.setItem("current_user", state.userId)
            }
        },
        setDiseaseDetails(state, action: PayloadAction<IProject>) {
            state.disease_details = action.payload;
        },
    },
});

export const { setClinicianDisease, setDiseaseDetails } = clinicianDiseaseSlice.actions;
export default clinicianDiseaseSlice.reducer;

export const getClinicianDisease = (state: RootState) => state.clinicianDisease;
